import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  className = '', 
  href,
  onClick,
  disabled = false,
  status,
  ...props 
}) => {
  // Base classes following the design system
  const baseClasses = 'inline-flex items-center justify-center px-6 py-3 rounded-full font-medium transition-all duration-200';
  
  // Variant specific classes
  const variantClasses = {
    primary: 'bg-gradient-to-r from-[#FFE135] via-[#FF4500] to-[#2E0854] text-white hover:opacity-90',
    secondary: 'bg-white text-[#2E0854] border-2 border-[#2E0854] hover:bg-gray-50'
  };

  // Status specific classes
  const statusClasses = {
    soldOut: 'bg-gray-300 text-gray-600 border-gray-400 cursor-not-allowed hover:bg-gray-300',
    comingSoon: 'bg-gray-100 text-gray-500 border-gray-300 cursor-not-allowed hover:bg-gray-100',
    earlyBird: 'bg-green-500 text-white hover:bg-green-600',
    limited: 'bg-yellow-500 text-white hover:bg-yellow-600'
  };

  const getButtonClasses = () => {
    if (status && statusClasses[status]) {
      return `${baseClasses} ${statusClasses[status]} ${className}`;
    }
    return `${baseClasses} ${variantClasses[variant]} ${className}`;
  };

  const getButtonText = () => {
    if (status === 'soldOut') return 'Sold Out';
    if (status === 'comingSoon') return 'Coming Soon';
    if (status === 'limited') return 'Limited Tickets Left';
    return children;
  };

  // If href is provided and button is not disabled/sold out, render an anchor tag
  if (href && !disabled && !status) {
    return (
      <a 
        href={href}
        className={getButtonClasses()}
        target={href.startsWith('http') ? '_blank' : undefined}
        rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
        {...props}
      >
        {getButtonText()}
      </a>
    );
  }

  // Otherwise render a button
  return (
    <button 
      className={getButtonClasses()}
      onClick={onClick}
      disabled={disabled || status === 'soldOut' || status === 'comingSoon'}
      {...props}
    >
      {getButtonText()}
    </button>
  );
};

export default Button;